<template>
  <v-app class="app">
    <transition name="fade" mode="out-in" type="transition">
      <div v-if="init" class="cover">
        <img class="cover-image logo--shadow" src="@/assets/img/ruishishu.png" alt="">
      </div>
      <router-view v-else></router-view>
    </transition>

    <app-overlay-loading
      :loading="appLoading"
      :size="70"
      :width="7"
      :fixed="true">
      <span class="title mt-4">Loading...</span>
    </app-overlay-loading>
  </v-app>
</template>

<script>
import {mapActions} from 'vuex';
import {mapState} from 'vuex';

export default {
  name: 'App',

  data() {
    return {
      init: true
    };
  },

  computed: {
    ...mapState({
      appLoading: state => state.appLoading
    })
  },

  async created() {
    await this.initApp();
    setTimeout(() => {
      this.init = false;
    }, 2000);
  },

  methods: {
    ...mapActions(['initApp'])
  }
};
</script>

<style lang="stylus" scoped>
.app {
  background-image: radial-gradient(#f9f9f9, #cbd3db);
  background-attachment: fixed;
  background-size: cover;
}

.cover {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh
}

.cover-image {
  max-width: 200px;
  max-height: 200px;
}
</style>
